import { render } from "./BtnOptionPhonemicConsonant.vue?vue&type=template&id=1a99dc4c&scoped=true"
import script from "./BtnOptionPhonemicConsonant.vue?vue&type=script&lang=js"
export * from "./BtnOptionPhonemicConsonant.vue?vue&type=script&lang=js"

import "@/css/components/btn-option-phonemic-consonant.css?vue&type=style&index=0&id=1a99dc4c&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a99dc4c"]])

export default __exports__